import storage from "../core/utils/storage";
import {Service} from './request';
import config from "../core/config/config";

export default {
    getImageUrl(url) {
        if (url) {
            return config.getImgBase() + url;
        }
        return "/static/head.jpg";
    },
    login(data) {
        return Service.post('/user/login', data)
    },
    getFriend() {
        return Service.post('/friend/get');
    },
    getOffline() {
        return Service.post('/message/get/offline');
    },
    clearOffline(ids) {
        return Service.post('/message/clear/offline', {
            id: ids
        });
    },

    getTeam() {
        return Service.post('/team/get');
    },
    getUserDetail(id) {
        return Service.post('/user/detail/get', {
            userId: id
        });
    },
    //模糊查询好友
    searchMyFriend(params) {
        return Service.post('/user/query/page', params);
    },
    //申请好友
    addMyFriend(params) {
        return Service.post('/friend/apply', params);
    },
    /**
     * 上传文件
     * @param {Object} file
     * @param {Object} isTemp 是否临时文件 false表示永久文件
     * @param uploadComplete
     * @param uploadFailed
     * @param progressFunction
     */
    uploadFile(file, isTemp = false, uploadComplete, uploadFailed, progressFunction) {

        // let fileObj = document.getElementById("file").files[0]; // js 获取文件对象
        let url = config.getImgBase() + "/file/upload"; // 接收上传文件的后台地址

        let form = new FormData(); // FormData 对象
        form.append("file", file); // 文件对象
        form.append("isTemp", isTemp);
        let xhr;
        xhr = new XMLHttpRequest();  // XMLHttpRequest 对象
        xhr.open("post", url, true); //post方式，url为服务器请求地址，true 该参数规定请求是否异步处理。
        xhr.setRequestHeader('Authorization', storage.get('token'));
        // if (uploadComplete) {
        //     xhr.onload = uploadComplete; //请求完成
        // }
        if (uploadFailed) {
            xhr.onerror = uploadFailed; //请求失败
        }

        if (progressFunction) {
            xhr.upload.onprogress = progressFunction;//【上传进度调用方法实现】
        }
        xhr.upload.onloadstart = function (res) {//上传开始执行方法
            res.ot = new Date().getTime();   //设置上传开始时间
            res.oloaded = 0;//设置上传开始时，已上传的文件大小为0
        };

        xhr.send(form); //开始上传，发送form数据

        xhr.onreadystatechange = function () {
            //若响应完成且请求成功
            if (xhr.readyState === 4 && xhr.status === 200) {
                //do something, e.g. request.responseText
                if (uploadComplete) {
                    uploadComplete(xhr.response);
                }
            }
        };
    },
    /**
     * 上传临时文件
     * @param {Object} filePath
     */
    uploadFileTeam(filePath) {
        return this.uploadFile(filePath, true)
    },
    getFriendApply() {
        let param = {
            pageNum: 1,
            pageSize: 20,
            param: {
                userId: storage.get('userId')
            }
        };
        return Service.post('/friend/apply/query/page', param);
    },
    passFriendApply(friendId) {
        let param = {
            friendId: friendId
        };
        return Service.post('/friend/pass/apply', param);
    },
    deleteFriend(id) {
        let param = {
            id: id
        };
        return Service.post('/friend/delete/single', param);
    },

    /************交流中心相关****************/
    // 获取加入的所有群组
    getAllGroups() {
        return Service.post('/team/getAdmin');
    },
    // 新建群组
    newGroup(params) {
        return Service.post('/team/teamInviteListByA', params);
    },
    // 获取群聊名称和群组总人数
    getGroupNameNCount(params) {
        return Service.post('/team/getTeamMemberFirst', params);
    },
    // 获取群信息
    getGroupInfo(params) {
        return Service.post('/team/getTeamInMember', params);
    },
    // 修改群昵称
    editGroupName(params) {
        return Service.post('/team/saveTeamMessage', params);
    },
    // 移除群成员
    removeGroupMember(params) {
        return Service.post('/teamMem/removeList', params);
    },
    // 获取可以邀请的好友列表
    getCanInviteMemberList(params) {
        return Service.post('/team/getTeamListAdd', params);
    },
    // 邀请好友
    invitedFriend(params) {
        return Service.post('/team/inviteby', params);
    },
    // 退出群聊
    quitGroup(params) {
        return Service.post('/team/leave', params);
    },
    // 点击获取群成员信息
    getMemberInfo(params) {
        return Service.post('/teamMem/teamFriendAdmin', params);
    },
    // 所有联系人模糊搜索
    getFilterContacts(params) {
        return Service.post('/team/contUserOrTeamby', params);
    },
    //创建群聊模糊搜索
    getBuildFilter(params) {
        return Service.post('/team/contUser', params);
    },
    //添加备注名
    setAlias(params) {
        return Service.post('/friend/updateUserNote', params);
    },
    //收取websocket消息推送时获取好友备注
    getMessagePushAlias(params) {
        return Service.post('/user/getFriendName', params);
    },
    //解散群聊
    dismissGroup(params) {
        return Service.post('/team/closeTeam', params);
    },
    //验证是否被踢出群聊
    sendGroupTest(params) {
        return Service.post('/teamMem/memberTOrF', params);
    },
}